/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lab } from '../../models/lab';

export interface LabControllerFindLabByLanguage$Params {
  labId: string;
  language: string;
}

export function labControllerFindLabByLanguage(http: HttpClient, rootUrl: string, params: LabControllerFindLabByLanguage$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
  const rb = new RequestBuilder(rootUrl, labControllerFindLabByLanguage.PATH, 'get');
  if (params) {
    rb.path('labId', params.labId, {});
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lab>;
    })
  );
}

labControllerFindLabByLanguage.PATH = '/lab/{labId}/language/{language}';
